import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { Patient } from 'types/patient';

type PatientItemModuleProps = {
  patient: Patient;
};

const PatientItemModule: React.FC<PatientItemModuleProps> = ({ patient }) => {
  return (
    <ModuleCard
      title={patient.name}
      subtitle={patient.email || undefined}
      status={patient.formattedActive}
      statusTone={patient.active ? 'success' : 'default'}
      muted={!patient.active}
      dense
      fields={[
        { label: 'CPF/CNPJ', value: patient.document_number },
        { label: 'Telefone', value: patient.phone },
        { label: 'Cidade', value: patient.formattedCityState, fullWidth: true },
      ]}
      onClick={() => history.push(`/patients/${patient.id}`)}
    />
  );
};

export default PatientItemModule;
